import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface YobiSupportMessage {
  interaction_id: string;
  interaction_dt: string;
  text_body: string;
  direction: 'inbound' | 'outbound';
  user_id?: string;
  sender_name?: string;
  channel_type: string;
  status: string;
}

@Injectable({
  providedIn: 'root',
})
export class YobiSupportViewModel {
  // Subject to emit new incoming messages
  newMessage$ = new Subject<YobiSupportMessage>();

  // Store the yobi support contact ID (converted to string for API calls)
  yobiSupportContactId$ = new BehaviorSubject<string | null>(null);

  // Unread message count for notification badge
  unreadMessageCount$ = new BehaviorSubject<number>(0);

  constructor() {}

  /**
   * Set the Yobi Support contact ID
   */
  setYobiSupportContactId(contactId: string | null): void {
    this.yobiSupportContactId$.next(contactId);
  }

  /**
   * Add a new message to the Yobi Support panel
   * This method should be called when a socket message for Yobi channel is received
   */
  addNewMessage(message: YobiSupportMessage): void {
    this.newMessage$.next(message);

    // Increment unread count only for inbound messages
    if (message.direction === 'inbound') {
      this.unreadMessageCount$.next(this.unreadMessageCount$.value + 1);
    }
  }

  /**
   * Clear the unread message count when user opens the support panel
   */
  clearUnreadCount(): void {
    this.unreadMessageCount$.next(0);
  }
}
